/**
 * Application initialization and routing
 */

import { Header } from './components/Header/Header.js';
import { Footer } from './components/Footer/Footer.js';
import { HomePage } from './pages/HomePage/HomePage.js';

/**
 * Initialize the application
 */
export function initApp() {
  console.log('initApp called');
  const app = document.getElementById('app');
  
  if (!app) {
    console.error('App container not found');
    return;
  }

  console.log('App container found, initializing components...');

  // Initialize header
  try {
    const header = new Header();
    app.appendChild(header.render());
    console.log('Header rendered');
  } catch (e) {
    console.error('Error rendering header:', e);
  }

  // Initialize main content based on current route
  try {
    const main = document.createElement('main');
    main.setAttribute('role', 'main');
    
    const currentPage = getCurrentPage();
    console.log('Current page:', currentPage);
    const pageComponent = createPageComponent(currentPage);
    console.log('Page component created');
    const pageContent = pageComponent.render();
    console.log('Page content rendered:', pageContent);
    main.appendChild(pageContent);
    
    app.appendChild(main);
    console.log('Main content appended');
  } catch (e) {
    console.error('Error rendering main content:', e);
  }

  // Initialize footer
  const footer = new Footer();
  app.appendChild(footer.render());

  // Setup navigation
  setupNavigation();
}

/**
 * Get current page from URL
 */
function getCurrentPage() {
  const path = window.location.pathname;
  if (path === '/' || path === '/index.html') {
    return 'home';
  }
  return path.slice(1).split('/')[0] || 'home';
}

/**
 * Create page component based on route
 */
function createPageComponent(page) {
  const pageMap = {
    'home': HomePage,
    // Add more pages here as you create them
  };

  const PageClass = pageMap[page] || HomePage;
  return new PageClass();
}

/**
 * Setup client-side navigation
 */
function setupNavigation() {
  document.addEventListener('click', (e) => {
    const link = e.target.closest('a[href^="/"]');
    if (link && !link.hasAttribute('data-external')) {
      e.preventDefault();
      const href = link.getAttribute('href');
      window.history.pushState({}, '', href);
      // Trigger page change (you can enhance this with a router)
      window.dispatchEvent(new PopStateEvent('popstate'));
    }
  });

  window.addEventListener('popstate', () => {
    // Handle browser back/forward
    const hash = window.location.hash;
    if (hash) {
      const target = document.querySelector(hash);
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  });

  // Handle initial hash on load
  if (window.location.hash) {
    setTimeout(() => {
      const target = document.querySelector(window.location.hash);
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 100);
  }
}
